<template>
	<page-content bgClass="bg-#0E0E0E" :triggered="triggered" :more="more" needMore @scrolltolower="scrolltolower"
		@refresherpulling="refresherpulling">
		<template v-slot:navBar>
			<home-nav :title="$t('销毁挖矿.销毁挖矿')" :showLang="true"></home-nav>
		</template>
		<template v-slot:content>

			<div class="px-30 pt-20 pb-140">
				<div class="nft-item1-bg-image p-30">
					<div class="flex items-center">
						<img class="w-36 h-36" src="@/assets/images/pages/destroy-mining/xhsj.png" alt="" />
						<div class="ml-20">
							<span class="text-36 text-white font-bold">{{$t('销毁挖矿.实时销毁数据')}}</span>
						</div>
					</div>
					<div class="mt-30 flex items-center justify-between">
						<div class="rounded-20 p-20 flex-1 mr-10" style="background-color: #441201;">
							<div class="flex items-center">
								<img class="w-34 h-34" src="@/assets/images/pages/destroy-mining/qwxh.png" alt="" />
								<span class="ml-10 text-26 text-#ccc">{{$t('销毁挖矿.全网销毁')}}</span>
							</div>
							<div class="mt-20">
								<span class="text-36 text-primary font-bold">{{totalDestroyed}}</span>
							</div>
							<div class="mt-10">
								<span class="text-20 text-#999">ROON</span>
							</div>
						</div>
						<div class="ml-20 rounded-20 p-20 flex-1" style="background-color: #441201;">
							<div class="flex items-center">
								<img class="w-34 h-34" src="@/assets/images/pages/destroy-mining/wdxh.png" alt="" />
								<span class="ml-10 text-26 text-#ccc">{{$t('销毁挖矿.我的销毁')}}</span>
							</div>
							<div class="mt-20">
								<span class="text-36 text-primary font-bold">{{my_amount}}</span>
							</div>
							<div class="mt-10">
								<span class="text-20 text-#999">ROON</span>
							</div>
						</div>
					</div>

                    <div class="mt-30 flex items-center justify-between">
                        <div class="rounded-20 p-20 flex-1 mr-10" style="background-color: #441201;">
                            <div class="flex items-center">
                                <img class="w-34 h-34" src="@/assets/images/pages/destroy-mining/qwxh.png" alt="" />
                                <span class="ml-10 text-26 text-#ccc">{{$t('销毁挖矿.占比')}}</span>
                            </div>
                            <div class="mt-20">
                                <span class="text-36 text-primary font-bold">{{proportion}}%</span>
                            </div>
                            <div class="mt-10">
                                <span class="text-20 text-#999">&nbsp;</span>
                            </div>
                        </div>
                        <div class="ml-20 rounded-20 p-20 flex-1" style="background-color: #441201;">
                            <div class="flex items-center">
                                <img class="w-34 h-34" src="@/assets/images/pages/destroy-mining/wdxh.png" alt="" />
                                <span class="ml-10 text-26 text-#ccc">余额</span>
                            </div>
                            <div class="mt-20">
                                <span class="text-36 text-primary font-bold">{{roon_balance}}</span>
                            </div>
                            <div class="mt-10">
                                <span class="text-20 text-#999">ROON</span>
                            </div>
                        </div>
                    </div>


                    <div class="mt-20 flex justify-between">
                        <div class="flex-1 mr-10 h-80 rounded-20 bg-primary flex items-center justify-center" @click="showTx()">
                            <span class="text-28 text-white font-bold">{{$t('销毁挖矿.提现')}}</span>
                        </div>
                        <div class="flex-1 ml-10 h-80 rounded-20 bg-white/10 flex items-center justify-center" @click="goLog">
                            <span class="text-28 text-white font-bold">{{$t('销毁挖矿.明细')}}</span>
                        </div>
                    </div>

<!--					<div class="mt-20 px-20 h-60 flex items-center justify-center rounded-20" style="background-color: #441201;">-->
<!--						<img class="w-24 h-24" src="@/assets/images/pages/destroy-mining/zb.png" alt="" />-->
<!--						<span class="ml-10 text-24 text-primary">{{$t('销毁挖矿.占比')}}</span>-->
<!--						<span class="ml-10 text-24 text-primary">{{proportion}}%</span>-->
<!--					</div>-->
				</div>
				<div class="flex items-center justify-between mt-20">
					<div class="dividend-pool-item1-bg-image rounded-20 p-30">
						<div>
							<img class="w-58 h-58" src="@/assets/images/pages/destroy-mining/yxh.png" alt="" />
						</div>
						<div class="mt-20">
							<span class="text-40 font-bold" style="color: #FF0101;">{{my_all_number}}</span>
						</div>
						<div class="mt-20">
							<span class="text-20 text-#ccc">总释放</span>
						</div>
					</div>
					<div class="dividend-pool-item1-bg-image rounded-20 p-30">
						<div>
							<img class="w-58 h-58" src="@/assets/images/pages/destroy-mining/scz.png" alt="" />
						</div>
						<div class="mt-20">
							<span class="text-40 font-bold" style="color: #01BAFF;">{{direct_rato}}%</span>
						</div>
						<div class="mt-20">
							<span class="text-20 text-#ccc">{{$t('销毁挖矿.分享收益')}}</span>
						</div>
					</div>
					<div class="dividend-pool-item1-bg-image rounded-20 p-30">
						<div>
							<img class="w-58 h-58" src="@/assets/images/pages/destroy-mining/klq.png" alt="" />
						</div>
						<div class="mt-20">
							<span class="text-40 font-bold" style="color: #01FF6D;">{{my_has}}</span>
						</div>
						<div class="mt-20">
							<span class="text-20 text-#ccc">已释放</span>
						</div>
					</div>
				</div>
				<div class=" my-30 flex items-center justify-between rounded-22 h-90 bg-white/10">
					<div @click="setQueryInfo(1)" :class="[queryInfo.type == 1 ? 'bg-primary' : '']" class="rounded-22 flex-1 h-90 flex items-center justify-center">
						<span class="text-32 text-white">{{$t('销毁挖矿.开始销毁')}}</span>
					</div>
					<div @click="setQueryInfo(2)" :class="[queryInfo.type == 2 ? 'bg-primary' : '']" class="rounded-22 flex-1 h-90 flex items-center justify-center">
						<span class="text-32 text-white">{{$t('销毁挖矿.销毁记录')}}</span>
					</div>
				</div>
				<!-- 开始销毁 -->
				<div v-if="queryInfo.type == 1" class="">
					<div class="py-20 flex items-center justify-between">
						<span class="text-32 text-white">{{$t('销毁挖矿.选择销毁档位')}}</span>
						<span class="text-24 text-primary">{{typeListCount}}{{$t('销毁挖矿.个档位可选')}}</span>
					</div>
					<div class="mt-20 flex flex-wrap">
						<div @click="form.type = item.id" v-for="(item, index) in typeList" :key="index"
						:class="[item.id == form.type ? 'border-#FF5134 bg-#280D03' : 'border-#212122 bg-#19191A']"
						 class="w-204 rounded-20 m-10 p-20 relative border border-solid">
						 <div class="absolute top-0 right-0 flex items-center justify-center p-10">
							 <img v-if="item.id == form.type" class="w-36 h-36" src="@/assets/images/pages/destroy-mining/xz_s.png" alt="" />
							 <img v-else class="w-36 h-36" src="@/assets/images/pages/destroy-mining/xz_n.png" alt="" />
						 </div>
							<div class="flex items-center justify-center">
								<img class="w-56 h-56" src="@/assets/images/pages/destroy-mining/roon.png" alt="" />
							</div>
							<div class="mt-20 text-center ">
							 <span  :class="[item.id == form.type ? 'text-primary' : 'text-white']" class="text-40 font-bold">{{item.number}}</span>
							</div>
							<div class="text-center ">
							 <span  :class="[item.id == form.type ? 'text-primary' : 'text-white']" class="text-20">ROON</span>
							</div>
							<div class="mt-20 bg-primary rounded-full h-32 flex items-center justify-center">
							 <span class="text-18 text-white">{{item.multiple}}x</span>
							</div>
							<div class="mt-20 flex items-center justify-between">
							 <span class="text-24 text-primary">{{item.all_number}}</span>
							 <span class="text-24 text-primary">{{item.day}}{{$t('销毁挖矿.天')}}</span>
							</div>
						</div>
					</div>

					<div class="mt-20 flex items-center justify-center">
						<div class="w-630 h-100 bg-primary rounded-full flex items-center justify-center" @click="destroy">
							<span class="text-32 text-white">{{$t('销毁挖矿.确认销毁')}}</span>
						</div>
					</div>
				</div>
				<!-- 销毁记录 -->
				<div v-else-if="queryInfo.type == 2" class="">
					<div v-for="(item, index) in destroy_users" :key="index" class="bg-white/10 p-20 rounded-20 mb-20">
						<div class="flex items-center justify-between">
							<div class="flex items-center justify-center">
								<img class="text-58 h-58" src="@/assets/images/pages/destroy-mining/xh.png" alt="" />
							</div>
							<div class="ml-20 flex-1">
								<div class="flex items-center justify-between">
									<span class="text-32 text-white font-bold">{{item.amount}}ROON</span>
									<span class="text-32 text-primary font-bold">{{item.all_number}}</span>
								</div>
								<div class="flex items-center justify-between">
									<span class="text-20 text-#ccc">{{item.all_number}}</span>
									<span class="text-20 text-#ccc">{{$t('销毁挖矿.总收益')}}</span>
								</div>
							</div>
						</div>
						<div class="mt-20 flex items-center justify-between">
							<span class="text-20 text-#999">{{$t("销毁挖矿.释放进度")}}</span>
							<span class="text-24 text-primary">{{item.progress}}%</span>
						</div>
						<div class="mt-20 h-16 rounded-full bg-white/10 overflow-hidden">
							<div class="h-16 bg-primary rounded-full" :style="{width: item.progress + '%'}"></div>
						</div>
						<div class="mt-20 flex items-center justify-between">
							<div class="rounded-12 flex-1 mr-10 h-110 p-20" style="background-color: #131314;">
								<div class="">
									<span class="text-20 text-#999">{{$t("销毁挖矿.每日释放")}}</span>
								</div>
								<div class="mt-10">
									<span class="text-32 text-white font-bold">{{item.day_release}}</span>
								</div>
							</div>
							<div class="rounded-12 flex-1 mr-10 h-110 p-20" style="background-color: #131314;">
								<div class="">
									<span class="text-20 text-#999">{{$t("销毁挖矿.已到账")}}</span>
								</div>
								<div class="mt-10">
									<span class="text-32 text-white font-bold">{{item.has_number}}</span>
								</div>
							</div>
							<div class="rounded-12 flex-1  h-110 p-20" style="background-color: #131314;">
								<div class="">
									<span class="text-20 text-#999">{{$t("销毁挖矿.待释放")}}</span>
								</div>
								<div class="mt-10">
									<span class="text-32 text-white font-bold">{{item.surplus_number}}</span>
								</div>
							</div>
						</div>
						<div class="mt-20 flex items-center justify-center h-80 bg-primary/20 rounded-20">
							<div class="bg-primary rounded-full w-10 h-10"></div>
							<span class="ml-10 text-24 text-primary">{{$t("销毁挖矿.自动释放中")}}</span>
						</div>
					</div>
				</div>
			</div>
		</template>
		<template v-slot:menuBar>
			<menu-bar-destroy activeMenu="destroy-mining"></menu-bar-destroy>
		</template>
		<template v-slot:popup>
            <van-popup v-model="showAmountPopup" position="center" round>
                <div class="w-690">
                    <div class="bg-#0F0F17 rounded-20 w-690 relative pt-100 pb-30 px-30" style="margin-top: -98rem;">
                        <div class="flex items-center justify-between mt-20">
                            <span class="text-36 text-white">ROON{{$t("销毁挖矿.提现")}}</span>
                            <img @click="showAmountPopup = false" class="w-40 h-40" src="@/assets/images/pages/usdr-swap/icon_gb.png" alt="" />
                        </div>
                        <div class="flex items-center mt-20">
                            <span class="text-26 text-#999">{{$t("USDR闪兑.可用余额")}}</span>
                            <span class="text-26 text-primary ml-20">{{roon_balance}}</span>
                        </div>
                        <div class="mt-20">
                            <span class="text-26 text-#999">{{$t("USDR闪兑.提现数量")}}</span>
                        </div>
                        <div class="h-110 rounded-18 bg-#1B1B1B flex items-center justify-between mt-20 mx-20 px-30">
                            <input class="flex-1 text-32 text-white" v-model="withdrawal_number" @input="handleWithdrawalInput" type="text" inputmode="decimal" :placeholder="$t('USDR闪兑.请输入数量')" />
                            <img class="w-50 h-50" src="@/assets/images/pages/swap/roon.png" alt="" />
                        </div>
                        <div class="mt-40 flex items-center justify-center">
                            <div @click="withdrawal" class="w-630 h-100 bg-primary rounded-full flex items-center justify-center">
                                <span class="text-32 text-white">{{$t('闪兑.确认')}}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </van-popup>

            <van-overlay :show="swapping" :z-index="100000" lock-scroll>
                <div class="w-full h-full flex items-center justify-center">
                    <div class="px-40 py-30 bg-#1B1B1B rounded-20 flex items-center">
                        <van-loading type="spinner" color="#EB470C" size="28px" />
                        <span class="ml-16 text-28 text-white">Loading…</span>
                    </div>
                </div>
            </van-overlay>

			<van-overlay :show="paying" :z-index="9999" class-name="flex items-center justify-center">
				<div class="flex flex-col items-center justify-center h-full" @click.stop>
					<van-loading type="spinner" color="#5ACC3C" size="40px" vertical>
						<span class="mt-20 text-white text-28">Loading...</span>
					</van-loading>
				</div>
			</van-overlay>
		</template>
	</page-content>
</template>

<script>
	import {
		ajaxData
	} from "@/request/ajax";
	import homeNav from '@/components/home-nav/home-nav.vue';
	import menuBarDestroy from '@/components/menu-bar-destroy/menu-bar-destroy.vue';
	import router from "@/router";
	import utils from "@/utils/utils.js";
	import store from "@/store/index.js";
	import PledgeAbi from "@/abi/PledgeAbi"
	import MainTokenDestroyAbi from "@/abi/MainTokenDestroyAbi"
	import Mining_Abi from "@/abi/MiningAbi";
	import {
		getShowAddress,
		setShowAddress
	} from "@/libs/util";
	import Web3 from "web3";
	export default {
		components: {
			homeNav,
			menuBarDestroy,
		},
        data() {
            return {
                triggered: false,
                more: 1,
                typeListCount: 0,
                proportion: 0,
                my_amount: 0,
                my_all_number: 0,
                my_surplus_number: 0,
                my_has: 0,
                address: "",
                direct_rato: "0",
                DestroyAddress: "0xd8659c79CAc2eF8E8088e999EdF0D6fBa2B6E4bd",
                typeList: [],
                destroy_users: [],
                queryInfo: {
                    page: 1,
                    type: 1
                },
                form: {
                    type: 1,
                    amount: 0,
                    dd_roon: 0,
                    amount_id: 0
                },
                paying: false,
                // 合约返回的全网销毁总量（按 18 位小数转换成主币单位字符串）
                totalDestroyed: '0',

                // 提现相关
                showAmountPopup: false,
                swapping: false,
                withdrawal_number: 0,
                roon_balance: "0.00",
                roon_number: "1000",
                total_address: "", // 接收提现的地址
                web3: null,
                web3Provider: null,
            };
        },
		computed: {
			lang() {
				return store.state.language;
			},
		},
        created() {
            let vm = this
            if (window.ethereum) {
                vm.web3Provider = window.ethereum
                vm.web3 = new Web3(vm.web3Provider);
            }
            vm.getIndex()
            // vm.getWithdrawInfo() // 获取提现所需的余额和地址信息
        },
        methods: {
            // 获取提现相关信息（复用/usdr/roon接口或类似逻辑）
            getWithdrawInfo() {
                let vm = this
                ajaxData("/usdr/roon").then(res => {
                    if(res.data) {
                        vm.roon_balance = parseFloat(res.data.roon_balance).toFixed(2);
                        vm.total_address = res.data.total_address;
                    }
                }).catch(err => {
                    console.error("获取提现信息失败", err);
                })
            },
            // 显示提现弹窗
            showTx(){
                // type: 2 for ROON
                // this.form.type = type; // 移除此行，避免影响销毁档位的选择
                this.showAmountPopup = true;
            },
            // 提现数量输入处理
            handleWithdrawalInput(){
                const vm = this;
                let val = String(vm.withdrawal_number ?? "");
                val = val.replace(/[^\d.]/g, '');
                const dotIndex = val.indexOf('.');
                if (dotIndex !== -1) {
                    val = val.slice(0, dotIndex + 1) + val.slice(dotIndex + 1).replace(/\./g, '');
                }
                if (val.startsWith('.')) val = '0' + val;
                vm.withdrawal_number = val;
            },
            async withdrawal(){
                const vm = this;
                try {
                    const num = parseFloat(vm.withdrawal_number);
                    if (!Number.isFinite(num) || num <= 0) {
                        vm.$message.error("请先输入金额");
                        return;
                    }

                    if (!vm.web3 || !vm.address) {
                        vm.$message.error(utils.$t("吐司.请在钱包中打包"));
                        return;
                    }

                    // 校验当前网络是否为 ROON 主链（chainId = 1314520 -> 实际上代码里是 1492）
                    const currentChainId = await vm.web3.eth.getChainId().catch(() => null);
                    if (currentChainId !== 1492) {
                        vm.$message.error("请切换到 ROON 主链");
                        return;
                    }

                    let walletAccount = null;
                    try {
                        if (window?.ethereum?.request) {
                            const accounts = await window.ethereum.request({ method: 'eth_requestAccounts' });
                            walletAccount = accounts && accounts[0] ? accounts[0] : null;
                        } else {
                            const accounts = await vm.web3.eth.getAccounts();
                            walletAccount = accounts && accounts[0] ? accounts[0] : null;
                        }
                    } catch (e) {
                        vm.$message.error("请连接钱包");
                        return;
                    }
                    if (!walletAccount) {
                        vm.$message.error("请连接钱包");
                        return;
                    }
                    vm.address = walletAccount;

                    const recipient = vm.total_address;
                    if (!recipient) {
                        vm.$message.error(utils.$t("吐司.收款地址无效"));
                        return;
                    }

                    // 余额检查
                    if (num > parseFloat(vm.roon_balance)) {
                        vm.$message.error(utils.$t("吐司.余额不足"));
                        return;
                    }

                    vm.swapping = true;

                    // 构造交易
                    const weiValue = vm.web3.utils.toWei(String(vm.roon_number), 'ether');
                    const gasPrice = await vm.web3.eth.getGasPrice();

                    const txParams = {
                        from: vm.address,
                        to: recipient,
                        value: vm.web3.utils.toHex(weiValue),
                        gasPrice: vm.web3.utils.toHex(gasPrice)
                    };

                    // 估算 Gas
                    try {
                        const gasLimit = await vm.web3.eth.estimateGas(txParams);
                        txParams.gas = vm.web3.utils.toHex(gasLimit);
                    } catch (e) {
                        console.warn('Gas估算失败，使用默认值', e);
                        txParams.gas = '0x5208'; // 21000
                    }

                    vm.web3.eth.sendTransaction(txParams)
                        .on('transactionHash', (hash) => {
                            console.log('交易哈希:', hash);
                            // 这里的 field 参数在 usdr-swap 中似乎对应币种类型?
                            // 在 usdr-swap 中: field = form.type (1=USDR, 2=ROON)
                            // 这里我们固定提现 ROON，所以 field = 2

                            ajaxData("/wallet/withdrawal",{
                                number: num,
                                currency_id: 2,
                                hash: hash,
                            }).then(res => {
                                console.log(res)
                                vm.withdrawal_number = 0
                                vm.$message.success("提现成功");
                                vm.showAmountPopup = false
                                vm.getIndex()
                                // vm.getWithdrawInfo() // 刷新余额
                            }).catch(err => {
                                console.error(err);
                                vm.$message.error(err?.message || "提现失败");
                            }).finally(() => {
                                vm.swapping = false;
                            })
                        })
                        .on('error', (err) => {
                            console.error('交易错误:', err);
                            vm.$message.error("交易取消或失败");
                            vm.swapping = false;
                        });

                } catch (err) {
                    console.error('交易异常:', err);
                    vm.$message.error(err?.message || utils.$t("吐司.操作失败"));
                    vm.swapping = false;
                }
            },

            goLog() {
                this.$router.push({
                    path: '/destroy-log'
                })
            },
            async destroy() {
                const vm = this;
                try {
                    vm.paying = true;

                    // 1) 获取选择的档位与支付金额（主币）
                    const selected = vm.typeList.find(item => item.id === vm.form.type);
                    if (!selected) {
                        console.error('未找到选择的销毁档位');
                        return;
                    }
                    const amount = selected.number; // 以主币为单位的金额

                    // 2) 准备 Web3 Provider（如 MetaMask）
                    // 已经在 created 中初始化 vm.web3，直接使用
                    if (!vm.web3) {
                         if (typeof window !== 'undefined' && window.ethereum) {
                            vm.web3 = new Web3(window.ethereum);
                         } else {
                            console.error('未检测到钱包提供者（如 MetaMask）');
                            return;
                         }
                    }

                    const accounts = await vm.web3.eth.getAccounts();
                    if (!accounts || accounts.length === 0) {
                        console.error('未获取到钱包账户');
                        return;
                    }
                    const from = accounts[0];
                    vm.address = from;

                    // 3) 初始化合约并构造交易
                    const contract = new vm.web3.eth.Contract(MainTokenDestroyAbi, vm.DestroyAddress);

                    // 将主币金额转换为最小单位（默认 18 位链）
                    const valueWei = vm.web3.utils.toWei(String(amount), 'ether');

                    // 可选：估算 Gas
                    let gas;
                    try {
                        gas = await contract.methods.destroy(vm.form.type).estimateGas({ from, value: valueWei });
                    } catch (e) {
                        console.warn('估算 Gas 失败，使用默认设置', e?.message || e);
                    }

                    const tx = contract.methods.destroy(vm.form.type);
                    const sendParams = { from, value: valueWei };
                    if (gas) sendParams.gas = gas;

                    const receipt = await tx.send(sendParams);
                    console.log('销毁交易成功', receipt);
                    if (vm && vm.$message && typeof vm.$message.success === 'function') {
                        vm.$message.success('销毁成功');
                    }

                    // 4) 刷新页面数据
                    vm.getIndex();
                    // vm.getTotalDestroyed()
                } catch (err) {
                    console.error('销毁操作失败', err?.message || err);
                    if (vm && vm.$message && typeof vm.$message.error === 'function') {
                        vm.$message.error(`销毁失败：${err?.message || err}`);
                    }
                } finally {
                    this.paying = false;
                }
            },
            async getTotalDestroyed() {
                try {
                    const vm = this;
                    let web3;
                    if (typeof window !== 'undefined' && window.ethereum) {
                        web3 = new Web3(window.ethereum);
                    } else if (Web3.givenProvider) {
                        web3 = new Web3(Web3.givenProvider);
                    } else {
                        console.error('未检测到钱包提供者（如 MetaMask）');
                        return;
                    }

                    const contract = new web3.eth.Contract(MainTokenDestroyAbi, vm.DestroyAddress);
                    const total = await contract.methods.getTotalDestroyed().call();
                    // 默认按 18 位精度，将最小单位转换为主币单位字符串
                    vm.totalDestroyed = Web3.utils.fromWei(String(total), 'ether');

                    // 计算个人占比：(my_amount / totalDestroyed) * 100
                    const totalVal = parseFloat(vm.totalDestroyed);
                    const myVal = parseFloat(vm.my_amount);
                    if (totalVal > 0) {
                        vm.proportion = ((myVal / totalVal) * 100).toFixed(2);
                    } else {
                        vm.proportion = 0;
                    }


                } catch (err) {
                    console.error('获取全网销毁总量失败', err?.message || err);
                }
            },
            async getIndex() {
                let vm = this
                getShowAddress()
                ajaxData("/destroy").then(res => {
                    console.log(res)
                    vm.roon_number = res.data.roon_number;
                    vm.total_address = res.data.total_address;
                    vm.direct_rato = res.data.direct_rato;
                    vm.roon_balance = res.data.roon_balance;
                    vm.destroy_users = res.data.destroy_users;
                    vm.my_amount = res.data.my_amount;
                    vm.my_all_number = res.data.my_all_number;
                    vm.my_surplus_number = res.data.my_surplus_number;
                    vm.my_has = res.data.my_has;
                    vm.address = res.data.address;
                    vm.typeList = res.data.destroy;
                    vm.typeListCount = vm.typeList.length;

                    // 读取合约的全网销毁总量
                    vm.getTotalDestroyed()
                })
            },
			setQueryInfo(type) {
				this.queryInfo.type = type;
				this.form.type = type;
			},
			scrolltolower() {
				console.log("滚动到底部/右边");
				this.triggered = true;
				setTimeout(() => {
					this.more = 0;
					this.triggered = false;
				}, 1000)
			},
			refresherpulling() {
				this.triggered = true;
				setTimeout(() => {
					this.triggered = false;
				}, 200)
				console.log("下拉刷新");
			}
		},
	};
</script>

<style scoped>

	.nft-item1-bg-image {
		width: 690rem;
		height: 600rem;
		background-image: url("~@/assets/images/pages/nft/itemBg1.png");
		background-size: 100% 100%;
		background-repeat: no-repeat;
		background-position: top center;
	}

	.dividend-pool-item1-bg-image {
		width: 218rem;
		height: 240rem;
		background-image: url("~@/assets/images/pages/destroy-mining/itemBg.png");
		background-size: 100%  auto;
		background-repeat: no-repeat;
		background-position: bottom;
		background-color: #19191A;
	}
</style>



